import axios from "axios";
import store from '@/vuex'

export default function getPageOj(route_path, cb) {

    axios.get('/api/test/school/oj/auth', {

        headers: {
            'Content-Type': 'application/json',
            'Authorization': store.getters.token,
            'X-Requested-With': "XMLHttpRequest"
        },

        params: {
            permission_key: route_path
        }
    })
        .then(function (response) {
            console.log("路由权限");
            console.log(response);
            cb(response);
        })
        .catch(function (error) {
            console.log(error);
        });


}
